import React, { Fragment } from "react";

import "./InsightList.scss";

export default class InsightList extends React.Component {
  componentDidCatch(error) {
    console.error(error);
  }

  getInsightItemClasses = (i) => {
    const classes = ["insights-list-item"];
    if (i === this.props.selectedInsightIndex) {
      classes.push("selected");
      if (this.props.autoplay) {
        classes.push("is-running");
      }
    } else if (i === this.props.selectedInsightIndex + 1) {
      classes.push("next");
    } else if (i === this.props.selectedInsightIndex - 1) {
      classes.push("prev");
    } else if (i > this.props.selectedInsightIndex) {
      classes.push("is-remaining");
    } else if (i < this.props.selectedInsightIndex) {
      classes.push("is-played");
    }
    return classes;
  };

  focusCurrentItem = (ref, i) => {
    if (i == this.props.selectedInsightIndex && ref) {
      ref.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  render() {
    const insights = this.props.insightList;
    return (
      <div className="insights-list">
        <div className="insights-list-actions">
          <a
            onClick={() => this.props.onAutoplayChange(!this.props.autoplay)}
            className="insights-list-autoplay"
          >
            <svg className="insights-list-autoplay-icon" viewBox="0 0 32 32">
              {!this.props.autoplay && <path d="M6 4l20 12-20 12z" />}
              {this.props.autoplay && <path d="M4 4h10v24h-10zM18 4h10v24h-10z" />}
            </svg>
            <span className="insights-list-autoplay-label">
              {this.props.autoplay ? "Pause" : "Play"}
            </span>
          </a>
        </div>
        {insights.map((d, i) => {
          const classes = this.getInsightItemClasses(i);
          return (
            <div
              key={i}
              ref={(ref) => this.focusCurrentItem(ref, i)}
              onClick={() => this.props.executeInsight(i)}
              className={classes.join(" ")}
            >
              <div className="insight-list-progress">
                <div className="insight-list-progress-animating" />
                <div className="insight-list-progress-line" />
                <div className="insight-list-progress-dot" />
              </div>
              <div className="insights-list-item-label">
                Step {i + 1}
                {/*d && d.stepInfo && d.stepInfo.action 
                    ? (
                      <div>
                        <div className={"insight-list-action "+(d.stepInfo.action.showing === null?"inactive":"")}>
                          <label className={"title-key"}>
                            Showing:
                          </label>
                          <label
                            className={"title-value"}
                            title={d.stepInfo.action.showing}>
                            {d.stepInfo.action.showing}
                          </label>
                        </div>
                        <div className={"insight-list-action "+(d.stepInfo.action.filter === null?"inactive":"")}>
                          <label className={"title-key"}>
                            Filter:
                          </label>
                          <label
                            className={"title-value"}
                            title={d.stepInfo.action.filter || "-"}>
                            {d.stepInfo.action.filter || "-"}
                          </label>
                        </div>
                        <div className={"insight-list-action "+(d.stepInfo.action.bucket === null?"inactive":"")}>
                          <label className={"title-key"}>
                            Bucket:
                          </label>
                          <label
                            className={"title-value"}
                            title={d.stepInfo.action.bucket || "-"}>
                            {d.stepInfo.action.bucket || "-"}
                          </label>
                        </div>
                      </div>
                    )
                    : (<div className="insights-list-item-template"><div/><div/><div/></div>)*/}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
